import { render, staticRenderFns } from "./UploadFilesPopup.vue?vue&type=template&id=2ff06fc8&"
import script from "./UploadFilesPopup.vue?vue&type=script&lang=ts&"
export * from "./UploadFilesPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports